import { render, staticRenderFns } from "./PuzzleNumberSquareForm.vue?vue&type=template&id=50b16aae&"
import script from "./PuzzleNumberSquareForm.vue?vue&type=script&lang=js&"
export * from "./PuzzleNumberSquareForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports